import { ERROR_HTTP_STATUS } from '@rp/contracts'
import { isApiError } from './error'

const ABSENT_STATUS = ERROR_HTTP_STATUS.NOT_FOUND

export const nullWhenAbsent = async <T>(load: Promise<T>): Promise<T | null> => {
  try {
    return await load
  } catch (error) {
    if (isApiError(error) && error.status === ABSENT_STATUS) return null
    throw error
  }
}
